export const subtitles = {
    "1": {
        "startTime": 1.52,
        "endTime": 7.89,
        "transcript": "Wani wangkuta imumi wani akaurteksaicaaquq yuullerput tau͡gaam...",
        "translation": "Now, it hasn't been a long time since our old lives, but..."
    },
    "2": {
        "startTime": 13.98,
        "endTime": 20.83,
        "transcript": "Yaa, waniwa-wa qanresqumiima qalarteqatalrianga wani.",
        "translation": "Okay, since I was asked to speak, I'm going to speak."
    },
    "3": {
        "startTime": 25.31,
        "endTime": 33.35,
        "transcript": "Wani qaillun wangkuta-wa aipangqerraallemteńi",
        "translation": "What we did when we first got married"
    },
    "4": {
        "startTime": 33.355,
        "endTime": 39.615,
        "transcript": "Qanruyutek'lallemteńek-llu qanresqumallrulrianga.",
        "translation": "And I was asked to speak about the traditional wisdom passed down to us."
    },
    "5": {
        "startTime": 40.336,
        "endTime": 52.821,
        "transcript": "Waniwa-llu akarutepiaqsaituq wani wangkuta yuullerput",
        "translation": "And now, it hasn't been too terribly long since our old lives."
    },
    "6": {
        "startTime": 53.269,
        "endTime": 64.198,
        "transcript": "Tau͡gaam wiinga wani qaqimalua ayagnillruunga-wa aipangqerrsaramek.",
        "translation": "But I was completely prepared on how to be married when I started."
    },
    "7": {
        "startTime": 64.201,
        "endTime": 74.03,
        "transcript": "Tau͡gaam maurluirutma-wa, mom-ama-llu, aatama-llu qanrut'lallruanga",
        "translation": "But my late grandmother, and my mom and father would tell me"
    },
    "8": {
        "startTime": 74.044,
        "endTime": 77.916,
        "transcript": "Aipamnun-wa tua-i mulngaklua pillerkamnek.",
        "translation": "That I should be careful with my spouse."
    },
    "9": {
        "startTime": 77.937,
        "endTime": 89.494,
        "transcript": "Cali-llu yuut assiinaku qanrutkengraatgu qanrut'laasqevkenaku.",
        "translation": "Also, they said that even though they speak badly about him not to tell him."
    },
    "10": {
        "startTime": 90.007,
        "endTime": 99.693,
        "transcript": "Cali-llu, cali aipangqellrianga kinguqlingqellrianga-w' angutmek",
        "translation": "Also, I have another with me, a male younger sibling."
    },
    "11": {
        "startTime": 99.71,
        "endTime": 111.41,
        "transcript": "Cali qanrut'lallruat, nulirra wani piciatun qanrutkengraatgu ukvekesqevkenaki iingakun tangenrrilkaku.",
        "translation": "They also used to tell not that no matter what people say about his wife, not to believe them if he didn't see it with his own eyes."
    },
    "12": {
        "startTime": 111.417,
        "endTime": 129.133,
        "transcript": "Tuaten-llu wiinga aatama qanrut'lallruagna. Piciatun tua-i-wa aipaqa kamakelaasqevkenaku wiinga piksailkuma, arnanun-llu allanun ellilalaasqevkenaku.",
        "translation": "That's what my father used to tell me to. He told me not to suspect my spouse if I hadn't done anything, and not to accuse him of being with other women."
    },
    "13": {
        "startTime": 129.136,
        "endTime": 135.453,
        "transcript": "Tamana-wa pim, nepngurutnguniluku.",
        "translation": "He said, you know, that brings discord."
    },
    "14": {
        "startTime": 135.467,
        "endTime": 144.033,
        "transcript": "Cali-llu uika-wa anagulluku ilangciaralaasqevkenaku qanrucimalallrulua.",
        "translation": "I was also told not to tease my husband too excessively."
    },
    "15": {
        "startTime": 144.044,
        "endTime": 155.277,
        "transcript": "Tuamtell' cali waten qanrutaqlua: caileng'e'rma canek-llu nuqlit'nge'rma waten qanlaasqevkenii: \"Piiturlua.\"",
        "translation": "Then he would also tell me this: even if I have nothing and I am short on things, never to say this: \"I am without.\""
    },
    "16": {
        "startTime": 155.289,
        "endTime": 162.839,
        "transcript": "Atam-gguq umyugaa pekcet'larniarqa taum aiparma.",
        "translation": "He said, watch, I will affect my husband's mental health."
    },
    "17": {
        "startTime": 162.856,
        "endTime": 165.656,
        "transcript": "Waten qanrucimalallruunga.",
        "translation": "This is what I was told."
    },
    "18": {
        "startTime": 165.68,
        "endTime": 174.947,
        "transcript": "Cali-llu kamakuurullunuk pilaasqevkenanuk inerquumalallruukuk.",
        "translation": "We were also admonished against being suspicious of each other."
    },
    "19": {
        "startTime": 174.964,
        "endTime": 179.131,
        "transcript": "Tau͡gaam-gguq pitulit aipateng kamaketuit.",
        "translation": "They said that only those who are guilty are suspicious of their spouses."
    },
    "20": {
        "startTime": 179.134,
        "endTime": 188.334,
        "transcript": "Tuamtell' cali ayagyuani, nasaurlurni, tan'gaurluni-llu maa-i ayagyualriani",
        "translation": "Then young people, girls and boys who are young now"
    },
    "21": {
        "startTime": 189.911,
        "endTime": 200.444,
        "transcript": "Cali qanruytetarluni ilateng mulngakluki, ilaput mulngakluki pilaasqelluki qanemteńek.",
        "translation": "There is also traditional wisdom saying that we should be careful with our mouths toward our peers."
    },
    "22": {
        "startTime": 200.454,
        "endTime": 204.821,
        "transcript": "Cali-llu qanengqerrnitkevkenata yuusqelluta.",
        "translation": "They also told us not to live life saying harsh things just because we have mouths."
    },
    "23": {
        "startTime": 205.055,
        "endTime": 215.788,
        "transcript": "Yurrluuvakalriit-gguq kiaresngiataallerkameggnun tekitaatuut, qanengqerrnitekvakalriit-llu.",
        "translation": "They say that wicked people and those who say harsh things come to times when they are ashamed."
    },
    "24": {
        "startTime": 215.815,
        "endTime": 225.398,
        "transcript": "Allayugtun-llu-gguq tangaatut tua-i ellait pisqucimegcetun.",
        "translation": "They say that they see things differently as they are told to."
    },
    "25": {
        "startTime": 225.403,
        "endTime": 237.819,
        "transcript": "Tuamtell' cali picilirtuumangramta neplingnaqevkenata uitalaasqaqluta wangkuta piksailkumta.",
        "translation": "Then, they also said that even if we are accused, to stay quietly if we hadn't done it."
    },
    "26": {
        "startTime": 238.273,
        "endTime": 241.306,
        "transcript": "Inerquutnguluni cali.",
        "translation": "That is also an admonishment."
    },
    "27": {
        "startTime": 243.002,
        "endTime": 253.202,
        "transcript": "Tuamtell' cali anagulluta yugnun, yugnaassiyaalaasqevkenata inerquumatullruluta.",
        "translation": "Then we were also admonished against going to people too much."
    },
    "28": {
        "startTime": 253.225,
        "endTime": 263.692,
        "transcript": "Atam-gguq cali umyuamta pekyutkaanun tekitelarniartukut, wall'u assiilngurnek niiqluta.",
        "translation": "Watch, they said, we would come across things that affect our mental health, or hear bad things."
    },
    "29": {
        "startTime": 265.406,
        "endTime": 271.756,
        "transcript": "Waten qanrucimalallruukut.",
        "translation": "This is what we were told."
    },
    "30": {
        "startTime": 271.866,
        "endTime": 284.883,
        "transcript": "Cali-llu kelguk'ngelaasqevkenata ilaput, ilaput tua-i-wa im'uluki",
        "translation": "They also told us not to invite our relatives to eat by treating them, well, you know"
    },
    "31": {
        "startTime": 284.896,
        "endTime": 292.412,
        "transcript": "Pingraitki qanqeryuutevkenata, cali nepngurutngulaan tamana.",
        "translation": "No matter what they do to them, do not be quick to say things, because that also leads to discord."
    },
    "32": {
        "startTime": 293.073,
        "endTime": 302.373,
        "transcript": "Tuamtell' cali wiinga qanrut'lakiinga-w' taum maurluirutma aatama-llu",
        "translation": "Then, my late grandmother and father would also tell me"
    },
    "33": {
        "startTime": 305.897,
        "endTime": 322.197,
        "transcript": "Inerciigapakarlua-gguq yugnun qanqevkarciqua, yuut-llu-gguq nani nunani nallunriciiqaatnga qaillun ayuquciqa.",
        "translation": "They said that if I am too mischievous, people will speak about me, and people in other villages will know what I'm like."
    },
    "34": {
        "startTime": 322.223,
        "endTime": 327.039,
        "transcript": "Maa-i wani yuut tamarmeng qanruyutekliniluku waten.",
        "translation": "Now, all people give that piece of wisdom."
    },
    "35": {
        "startTime": 327.06,
        "endTime": 332.16,
        "transcript": "Tuamtell' cali, tua-i-wa",
        "translation": "Also, well"
    },
    "36": {
        "startTime": 337.196,
        "endTime": 347.557,
        "transcript": "Inerqurnarqellriit-llu neplingnaqellriit inerquqa'aqluki pilarnaqluni.",
        "translation": "We need to admonish those who are mischievous and try to start a commotion."
    },
    "37": {
        "startTime": 347.942,
        "endTime": 357.875,
        "transcript": "Cali inerquutnguuq ilumun.",
        "translation": "Also, it truly is something admonished against."
    },
    "38": {
        "startTime": 358.648,
        "endTime": 367.748,
        "transcript": "Waten-llu tua-i aatama qanrut'lallruanga: nunanek allanek alaitaarlua pingnaqesqevkenii.",
        "translation": "My father also used to tell me this: that I shouldn't try to come up in other villages."
    },
    "39": {
        "startTime": 367.75,
        "endTime": 377.5,
        "transcript": "Tuamtell' call' nunakenrilkemnun ayakuma anagtevkenii.",
        "translation": "Then, if I travel to where it not my home village, I shouldn't [?misbehave]."
    },
    "40": {
        "startTime": 377.823,
        "endTime": 386.423,
        "transcript": "Cali-llu nunai allani uitakuma nepliutngungnaqevkenii.",
        "translation": "Also, if I were in another village, they told me not to be the source of commotion."
    },
    "41": {
        "startTime": 386.838,
        "endTime": 391.838,
        "transcript": "Ilamnun tuss'araulua-llu yuusqetullruanga.",
        "translation": "He also told me to live as a stepping stool for those around me."
    },
    "42": {
        "startTime": 394.557,
        "endTime": 409.057,
        "transcript": "Qanruyun-wa waten-llu qanrutaqlua: atunrilengramki umyuaqaqluki pikumki atulriatun piciqniluki.",
        "translation": "The traditional wisdom, they also used to tell me this: even if I don't experience them, if I remember them, it'll be like I experieced them."
    },
    "43": {
        "startTime": 422.354,
        "endTime": 434.12,
        "transcript": "Cali wani maa-i-wa tua-i mat'um nalliini akusrarrnarqellriit-llu amlleripiartut.",
        "translation": "Also, these days, there are now very many things that cause people to misbehave."
    },
    "44": {
        "startTime": 434.395,
        "endTime": 444.862,
        "transcript": "Tuamtell' cali maa-i wani waten nunani tarrteng'e'rma",
        "translation": "Then now, even when I wander around villages"
    },
    "45": {
        "startTime": 445.945,
        "endTime": 456.345,
        "transcript": "Umyuamnun-llu wani tamakut iliini kanalartut taum aatama maurluirutma-llu qanlallri.",
        "translation": "What my father and late grandmother said sometimes come up on my mind."
    },
    "46": {
        "startTime": 457.092,
        "endTime": 471.959,
        "transcript": "Taumek waten-llu tua-i nunanun ayagang'e'rma tau͡gaam ciunerramni, ciunerramini yuk qaillukuarpek'nani-llu uitalaquni assilaryartuq.",
        "translation": "That's why even though I travel to other villages, what's right in front of me, if a person focuses on what's in front of him and doesn't mess around, it would be good."
    },
    "47": {
        "startTime": 480.851,
        "endTime": 483.017,
        "transcript": "Cali-qaa?",
        "translation": "Anything else?"
    },
    "48": {
        "startTime": 483.043,
        "endTime": 487.61,
        "transcript": "Camek-llu? Wait.",
        "translation": "What else? Wait."
    },
    "49": {
        "startTime": 490.899,
        "endTime": 492.682,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "50": {
        "startTime": 494.3,
        "endTime": 507.65,
        "transcript": "Ava-i iciw', ava-i iciw'-llu qanellrulrianga wani aipam-wa tua-i qannguarulluku iqlutmurtellerkaanek.",
        "translation": "Just now, you know, I just said that saying speaking harshly to one's spouse makes things go wrong."
    },
    "51": {
        "startTime": 507.818,
        "endTime": 514.901,
        "transcript": "Tua-i-ll' waten cali qanrutaqlua:",
        "translation": "Then they would also tell me this:"
    },
    "52": {
        "startTime": 516.243,
        "endTime": 526.943,
        "transcript": "Tua-i-wa aipam uum uingulriim umyugaan akngirutekainek qanrut'laasqevkenaku.",
        "translation": "They said not to tell a spouse, a husband, things that would negatively affect his mental health."
    },
    "53": {
        "startTime": 526.95,
        "endTime": 537.717,
        "transcript": "Tuamtell' call' irniangama cali qanrucimalallruunga, qanrutaqluku tauna mikelnguq pisqelluku.",
        "translation": "Then I was also told when I had children, that I should instruct that child."
    },
    "54": {
        "startTime": 537.919,
        "endTime": 541.585,
        "transcript": "Mikelnguut-gguq nalluyagutaitut.",
        "translation": "They said children don't forget."
    },
    "55": {
        "startTime": 541.607,
        "endTime": 556.873,
        "transcript": "Tuamtellu inerquraqlua canek apqaulaasqevkenaku, wall' ilainun qaillun ayuqucianek apqaulaasqevkenaku.",
        "translation": "Then they would admonish me against asking him things, or asking him what his peers are like to him."
    },
    "56": {
        "startTime": 557.898,
        "endTime": 566.965,
        "transcript": "Cali-llu wani eyuqsaunaki. Nauwa ilait eyurnayugalalriit.",
        "translation": "I was also told not to verbally defend them. You know how some are verbally defensive."
    },
    "57": {
        "startTime": 566.968,
        "endTime": 574.184,
        "transcript": "Tua-i-ll' eyurnakeksaunaku-gguq, inerquraqluku tau͡gaam.",
        "translation": "Then they said not to verbally defend him, but to admonish him."
    },
    "58": {
        "startTime": 574.2,
        "endTime": 585.25,
        "transcript": "Tua-i-gguq-wa eyulaqumku-gguq iqluqullerkaanun, qannguatullerkaanun eguaqurciqaqa.",
        "translation": "They said that if I verbally defend him, I will encourage him to lie and slander."
    },
    "59": {
        "startTime": 585.255,
        "endTime": 597.572,
        "transcript": "Tuamtell' cali wani anagulluki yagiralaasqevkenaki inerqulallruatnga.",
        "translation": "Then they also admonished me against excessively raised a hand against them."
    },
    "60": {
        "startTime": 597.584,
        "endTime": 600.984,
        "transcript": "Atam-gguq asvaircarniarqa.",
        "translation": "They said I would make him stubborn."
    },
    "61": {
        "startTime": 601.512,
        "endTime": 611.196,
        "transcript": "Asvaircarilartut-gguq anagulluki yagiralluki wall'u qatpagalluki. Tua-i-gguq caceturcarluki.",
        "translation": "They say they make them stubborn when they raise their hands against them too much or shout at them. They say they make them insolent."
    },
    "62": {
        "startTime": 612.442,
        "endTime": 616.409,
        "transcript": "Caceturcalarait-gguq tuaten.",
        "translation": "They say that's how they make them insolent."
    },
    "63": {
        "startTime": 616.424,
        "endTime": 627.757,
        "transcript": "Mikelnguut makut eyurnakenrilngurtun ellirluki pinarqelliniut.",
        "translation": "It turns out, we must not be verbally defensive over these children."
    },
    "64": {
        "startTime": 630.342,
        "endTime": 638.759,
        "transcript": "Eyuratukait-gguq qannguarulluki-llu angayuqateng nep'ngevkatuit.",
        "translation": "They say that those they defend and those who slander other to their parents cause commotion."
    },
    "65": {
        "startTime": 639.062,
        "endTime": 643.445,
        "transcript": "Cali wiinga tamaa-i tuaten qanrucimalallrulua.",
        "translation": "I was also told that."
    },
    "66": {
        "startTime": 643.741,
        "endTime": 647.725,
        "transcript": "Mom-amnek-llu qanrucimalallrulua",
        "translation": "I was also told by my mother"
    },
    "67": {
        "startTime": 650.382,
        "endTime": 663.232,
        "transcript": "Pingraatnga-llu, iliini taqsuqa'arrlua-llu piyaaqaqama inerqulallruanga qanrutkelaasqevkenaki tamakut.",
        "translation": "No matter what they do to me, and when I sometimes got tired, she would admonish me against talking about those."
    },
    "68": {
        "startTime": 663.371,
        "endTime": 668.371,
        "transcript": "Atam-gguq ayagneqlua-llu yuut nepengniartut.",
        "translation": "She said people would start a commotion starting from me."
    },
    "69": {
        "startTime": 668.389,
        "endTime": 682.555,
        "transcript": "Tuamtell' cali pingraata qialua-llu utertelaasqevkenii inerquraqlua.",
        "translation": "Then no matter what anyone did to me, she admonished me against going home crying."
    },
    "70": {
        "startTime": 684.449,
        "endTime": 694.815,
        "transcript": "Tua-i-llu wiinga-llu atunrilengramki wani irnianka miklermeggni qialuteng itraqata",
        "translation": "And even though I was doing those things, when my children would come in crying when they were small"
    },
    "71": {
        "startTime": 694.831,
        "endTime": 704.365,
        "transcript": "Tua-i aatama-llu wiinga tuaten qanrut'lallruanga pinaqngama pinilua.",
        "translation": "My father would also tell me that, saying that I needed to be told."
    },
    "72": {
        "startTime": 704.567,
        "endTime": 710.667,
        "transcript": "Tua-i-ll' wiinga anagyaaqevkenii-llu pillruyuklua uitaaqlua.",
        "translation": "Then I would try not to leave, but stay thinking I had done it."
    },
    "73": {
        "startTime": 710.697,
        "endTime": 722.822,
        "transcript": "Tua-i-llu waten mikelnguut ciunermeggnun tamakut inerquumaaqameng",
        "translation": "Then children like this in their future, when they're admonished"
    },
    "74": {
        "startTime": 722.844,
        "endTime": 730.394,
        "transcript": "Anagyaaqevkenateng-llu taqtulliniut tua-i taqesqellriani.",
        "translation": "And they do not run away, but stop when told to stop."
    },
    "75": {
        "startTime": 730.415,
        "endTime": 735.182,
        "transcript": "Waten-llu pivkenaki: \"Piciqaqa tauna.\"",
        "translation": "And don't say this to them: \"I will get him.\""
    },
    "76": {
        "startTime": 735.193,
        "endTime": 742.227,
        "transcript": "Tuaten piyukait utqerteturituut-llu-gguq qialuteng enemeggnun elilluteng",
        "translation": "The children who are told that learn to go home crying"
    },
    "77": {
        "startTime": 742.24,
        "endTime": 748.89,
        "transcript": "Tua-i-ll' eyurnakuuryukait.",
        "translation": "Including the ones they verbally defend."
    },
    "78": {
        "startTime": 748.901,
        "endTime": 759.401,
        "transcript": "Taumek wani inerquutngullinilria iqluyaramun qannguaryaramun-llu agarutnguniluku tamana.",
        "translation": "That's why it's an admonished, because that makes them liars and slanderers."
    },
    "79": {
        "startTime": 761.224,
        "endTime": 776.174,
        "transcript": "Tuamtell' cali pinauraanga-llu imumi pava'antaqamta taum maurluirutma, uika cataunaku nerlaasqevkenii tau͡gaam utaqaurluku.",
        "translation": "Then my late grandmother would also tell me when we were inland back then, that I should eat when my husband is gone, but to wait for him."
    },
    "80": {
        "startTime": 776.186,
        "endTime": 787.019,
        "transcript": "Tua-i-ll' wani iliini wiinga wani arnassagarrlainarnek taqnessagarrlainarnek-llu ilanqessunqellruama",
        "translation": "Then, because I liked to be with only old women, and older adults"
    },
    "81": {
        "startTime": 787.033,
        "endTime": 792.667,
        "transcript": "Tauna maurluirutka tuaten qanrutaqanga ciin-aalallruaqa, \"Ciin?\"",
        "translation": "When my late grandmother told me that, I'd ask her why, \"Why?\""
    },
    "82": {
        "startTime": 792.698,
        "endTime": 810.481,
        "transcript": "Tua-i-ll' pilua, atam-gguq neqa-llu piilkan ilanka piilnguarulluki kiima nerlarniartua, ilamnek-llu-gguq paluilua, uika-llu-gguq paluvkarluku.",
        "translation": "Then she said to me that should there be a food shortage, I would pretend there's not enough for my family and eat alone, and my family will starve, and I will let my husband starve."
    },
    "83": {
        "startTime": 827.769,
        "endTime": 829.753,
        "transcript": "Yaa, tua-i-qaa?",
        "translation": "Okay, ready?"
    },
    "84": {
        "startTime": 830.093,
        "endTime": 838.859,
        "transcript": "Yaa, tua-ll', tua-llam cali waten cali tamaani wiinga yurrluurluama wani",
        "translation": "Okay, since I was a bad person at that time"
    },
    "85": {
        "startTime": 843.269,
        "endTime": 849.336,
        "transcript": "Waten-llu apqaurlua-llu ciin-aaraqluki-llu.",
        "translation": "I would ask questions like this and ask them why."
    },
    "86": {
        "startTime": 849.351,
        "endTime": 859.035,
        "transcript": "Ciin-aaraqlukek-wa taukuk Aanankuk mom-aq-llu pilallruagka, tau͡gaam aataka pisciigatellruaqa tuaten.",
        "translation": "I would as Aana and mom why, but I couldn't [ask why] with my father like that."
    },
    "87": {
        "startTime": 859.052,
        "endTime": 872.786,
        "transcript": "Tau͡gaam cali tamarmeng taukut qanrut'lallruatnga, wiinga-gguq yurrluuvakarlua, irnianek-llu-gguq akitekam iqukliqaarluku",
        "translation": "But all of them used to tell me that if I am too wicked of a person, and if I [stop taking care of] children after receiving money"
    },
    "88": {
        "startTime": 872.975,
        "endTime": 878.459,
        "transcript": "Ayuquciqa nasperturluku uniciiqaanga uima.",
        "translation": "My husband will decide to leave me because of my character."
    },
    "89": {
        "startTime": 878.88,
        "endTime": 891.046,
        "transcript": "Tuamtell' cali, cali angutet, angun-gguq cali inerciigapakarluni",
        "translation": "Then, they said that when a man is too disobedient"
    },
    "90": {
        "startTime": 891.057,
        "endTime": 905.623,
        "transcript": "Tua-i cali tuaten irnianek cali akin iqukliqaarluku unitelarait qanrucunaipakalriit.",
        "translation": "They also leave those who stop taking care of children after receiving money, and who do not heed advice."
    },
    "91": {
        "startTime": 907.023,
        "endTime": 919.24,
        "transcript": "Tua-i-ll' sagtengluteng. Uingesciigaliluteng. Tuamtell' cali angun nurlirturciigaliluni nallunriatni yuut.",
        "translation": "Then [the family] breaks up. They can't take husbands anymore. Then the man cannot take wives because people found out [what he's like]."
    },
    "92": {
        "startTime": 919.266,
        "endTime": 923.166,
        "transcript": "Qanrucunaipakalriit-gguq ilait-llu-gguq",
        "translation": "They said that some who do not heed advice"
    },
    "93": {
        "startTime": 927.922,
        "endTime": 930.689,
        "transcript": "Ilait-llu-gguq...",
        "translation": "They said that some..."
    },
    "94": {
        "startTime": 931.637,
        "endTime": 940.404,
        "transcript": "Waten-wa tua-i maa-i au͡g'umun-llu kinguqlimnun qanrutkelallrit tamakut aatama nallunrit'lallruanka.",
        "translation": "Well, I also knew what my father would say to my younger sibling."
    },
    "95": {
        "startTime": 940.431,
        "endTime": 944.748,
        "transcript": "Tuamtellu-gguq ilait angutet",
        "translation": "Then they said that some men"
    },
    "96": {
        "startTime": 950.355,
        "endTime": 959.238,
        "transcript": "Umyualinqigcugngang'e'rmi-gguq angutem ilii inerciigacimatuuq.",
        "translation": "They said that some men, though they can change their ways, are disobedient for a long time."
    },
    "97": {
        "startTime": 961.006,
        "endTime": 965.923,
        "transcript": "Angulluarluni-llu-gguq ilii umyualinqigtetuluni.",
        "translation": "And they say that some change their ways when they're old men."
    },
    "98": {
        "startTime": 967.046,
        "endTime": 975.079,
        "transcript": "Arnaq-gguq tau͡gken amlleq umyualinqigcuunani.",
        "translation": "They said that women, however, many do not change their ways."
    },
    "99": {
        "startTime": 975.091,
        "endTime": 981.475,
        "transcript": "Angutet-gguq tau͡gaam umyualinqigtenrutuut, umyualinqigtetuut.",
        "translation": "However, they say that men change their ways more easily, so they change their ways."
    },
    "100": {
        "startTime": 981.771,
        "endTime": 986.338,
        "transcript": "Arnat-gguq tau͡gken umyualinqigcuunateng.",
        "translation": "They said that women, however, do not change their ways."
    },
    "101": {
        "startTime": 986.361,
        "endTime": 992.661,
        "transcript": "Taumek-gguq arnani wangkuta ellatungnaqluta yuulalta.",
        "translation": "That's why they said we women should try to live sensibly."
    },
    "102": {
        "startTime": 996.584,
        "endTime": 1010.601,
        "transcript": "Ava-i ciuqlirmi niitellemcecicetun atunrilengramteggu umyuaqelaqumteggu pinriceńalarciqukut-gguq.",
        "translation": "As we just heard at first, though we do not do them, if we remember them, we will end up not doing them."
    },
    "103": {
        "startTime": 1010.744,
        "endTime": 1016.761,
        "transcript": "Kitaki-gguq tuaten yuulta emaitengnaqluta.",
        "translation": "Now, they said, that we should live quietly."
    },
    "104": {
        "startTime": 1042.775,
        "endTime": 1052.991,
        "transcript": "Tuamtellam call' waniwa arnaurtellemni wani qanrucimalallruunga",
        "translation": "Then when I became a woman, I would also be told"
    },
    "105": {
        "startTime": 1053.42,
        "endTime": 1068.686,
        "transcript": "Kitak'-gguq mikelnguunrirtua; arnaurtua. Tau͡gaam-gguq cat tamalkuita erurirrlainarlua tegulalaqilaki.",
        "translation": "Now, they said, I'm not a child anymore; I've become a woman. But, they said, that I should always wash my hands before taking anything."
    },
    "106": {
        "startTime": 1068.912,
        "endTime": 1079.312,
        "transcript": "Tuamtell' cali angutet akluit ayuqluki, aklut amlliralaasqevkenaki, neqet-llu.",
        "translation": "Then they said that I should not step over men's clothes the same way, clothes and food."
    },
    "107": {
        "startTime": 1082.748,
        "endTime": 1086.048,
        "transcript": "Amlliralaasqevkenaki neqet-llu.",
        "translation": "They told me not to step over them, including food."
    },
    "108": {
        "startTime": 1086.057,
        "endTime": 1091.574,
        "transcript": "Caarlugmek-gguq imkularaput, kanvelaraput.",
        "translation": "They said we scatter impurities on them."
    },
    "109": {
        "startTime": 1091.747,
        "endTime": 1102.131,
        "transcript": "Tuamtell' nuyanka angimalaasqevkenaki. Caarlugmek-gguq kuvuartelaraput, kanevluki.",
        "translation": "Then they told me not to leave my hair untied. They said we pour, we scatter impurities on things."
    },
    "110": {
        "startTime": 1102.282,
        "endTime": 1118.266,
        "transcript": "Tua-i-ll' cali maa-i wani kiirraramegnuk malruulunuk-wa angellruamegnuk kiimegnuk",
        "translation": "Then, since we were all by ourselves, since the two of us grew up alone"
    },
    "111": {
        "startTime": 1121.392,
        "endTime": 1130.69,
        "transcript": "Tuamtell' cali piaqlua-am caumapiiqnanuk arnaurrnilua.",
        "translation": "Then they would tell us not to play with each other, saying that I've become a woman."
    },
    "112": {
        "startTime": 1130.866,
        "endTime": 1134.866,
        "transcript": "Angutnun-gguq arnaurtaqameng mulngaktuut.",
        "translation": "They said they're careful around men when they become women."
    },
    "113": {
        "startTime": 1134.876,
        "endTime": 1139.476,
        "transcript": "Anerneteng-llu nuateng-llu mulngakluki.",
        "translation": "They're also careful with their breath and saliva."
    },
    "114": {
        "startTime": 1139.762,
        "endTime": 1149.345,
        "transcript": "Tua-i waniw' quyumegnuk tungeklunuk anguteku'urlunuk pillruamegnuk aatama qalarut'lallruakuk tuaten.",
        "translation": "Since we were together and with each other at the same age, my father would speak to us like that."
    },
    "115": {
        "startTime": 1149.358,
        "endTime": 1150.941,
        "transcript": "Tuamtellu-gguq",
        "translation": "Then they said"
    },
    "116": {
        "startTime": 1158.091,
        "endTime": 1167.724,
        "transcript": "Angutmek-gguq kituqengkuma anernerunii uqriqanga anernerunii kiturceskilii.",
        "translation": "They said that if I pass a man who id downwind from me, I should hold my breath and let him pass."
    },
    "117": {
        "startTime": 1167.745,
        "endTime": 1170.728,
        "transcript": "Anerneqa-gguq yuurrmigyuaraa.",
        "translation": "They said he might inhale my breath."
    },
    "118": {
        "startTime": 1170.749,
        "endTime": 1179.182,
        "transcript": "Tuamtell' cali, cali tauna aipaqa-wa au͡gna kinguqliqa",
        "translation": "Then, my companion also, my younger sibling"
    },
    "119": {
        "startTime": 1179.184,
        "endTime": 1189.167,
        "transcript": "Cali piaqluku arnamek kituqengkan asguakun kituusqelluku, arnam-llu asguiqaku anernerunaku kiturcetesqelluku.",
        "translation": "They also told him that if he passes a woman that he should pass upwind from her, and if a woman goes upwind from him, that he should hold his breath as she passes."
    },
    "120": {
        "startTime": 1191.498,
        "endTime": 1198.715,
        "transcript": "Yuurmignayukluku-gguq anernera.",
        "translation": "They said that he might inhale her breath."
    },
    "121": {
        "startTime": 1198.717,
        "endTime": 1204.267,
        "transcript": "Qaillun-llu tua-i tuaten pikatgu piluni yuurrmiqatgu, yuurmiqaku?",
        "translation": "Then what would happen if they inhaled it like that?"
    },
    "122": {
        "startTime": 1205.417,
        "endTime": 1212.917,
        "transcript": "Ak'a tamaani im'upiallrulliniut, restrict-apiallrulliniut yuut.",
        "translation": "Apparently, people had very strong restrictions a long time ago."
    },
    "123": {
        "startTime": 1216.938,
        "endTime": 1223.488,
        "transcript": "Arnat-llu, angutet arnat-llu caumacuunateng.",
        "translation": "And women, men and women wouldn't interact with each other."
    },
    "124": {
        "startTime": 1225.899,
        "endTime": 1233.982,
        "transcript": "Tua-i-gguq angutnun-llu maligtaqupakalriit arniqevkarituut.",
        "translation": "They said that those who submit to men too much drive them sex crazy."
    },
    "125": {
        "startTime": 1235.733,
        "endTime": 1242.133,
        "transcript": "Arniqellriit-llu-gguq tuquaqluteng, akurait aruluteng.",
        "translation": "They also say that those who are sex crazy die, their groins rotting."
    },
    "126": {
        "startTime": 1242.468,
        "endTime": 1248.585,
        "transcript": "Neryuirulluteng-llu ilait tuquluteng, ilait-llu-gguq uquriqerrluteng.",
        "translation": "They say some die when they stop eating, and some suddenly get overwight."
    },
    "127": {
        "startTime": 1249.019,
        "endTime": 1253.236,
        "transcript": "Maa-i qanrutkumalallret aarnarqellriit yugnun.",
        "translation": "These are the things they talked about that are dangerous to people."
    },
    "128": {
        "startTime": 1253.256,
        "endTime": 1261.106,
        "transcript": "Taumek ak'a tamaani yullret naulluuyuitellrullinilriit uqlautellrunritliniameng.",
        "translation": "That's why people a long time ago didn't get sick, because they weren't unclean."
    },
    "129": {
        "startTime": 1261.124,
        "endTime": 1270.224,
        "transcript": "Qantarluteng-llu ataucirrlainarnek angutet arnat-llu. Ayuqluteng qantateng mumigucuunaki.",
        "translation": "And the men and women only had single bowls [for each]. They were the same, and they didn't exchange their bowls."
    },
    "130": {
        "startTime": 1274.928,
        "endTime": 1279.845,
        "transcript": "Nuyateng-llu arnat sagingayuunaki.",
        "translation": "And the women wouldn't have disheveled hair."
    },
    "131": {
        "startTime": 1279.856,
        "endTime": 1291.023,
        "transcript": "Wiinga au͡gkuk ava-i wani aatankuk ataataq-llu nuyanka murilkepialallruakek. Taquicetqerciiganii-llu.",
        "translation": "Just now, my father and paternal uncle kept a very close eye on my hair. I couldn't ever go without braids."
    },
    "132": {
        "startTime": 1291.039,
        "endTime": 1296.272,
        "transcript": "Tua-i-gguq caarrlugnek naulluutekanek kanevnayuklua.",
        "translation": "They said it was because I might scatter impurities that would cause sickness."
    },
    "133": {
        "startTime": 1298.971,
        "endTime": 1301.855,
        "transcript": "Pilallruagnga tuaten.",
        "translation": "That's what they'd tell me."
    },
    "134": {
        "startTime": 1302.615,
        "endTime": 1313.082,
        "transcript": "Tuamtellu ilait arnat umyuartekvakalalriit-gguq angutnek uinguatuluteng.",
        "translation": "Then they said that some women who think too much about men have imaginary husbands."
    },
    "135": {
        "startTime": 1313.089,
        "endTime": 1318.756,
        "transcript": "Cali neryuirulluteng, aipangqerruarturangluteng-llu.",
        "translation": "They also stop eating, and always imagine having lovers."
    }
};